// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"469f855a","678":"d23da0d9","753":"dcff9ae0","787":"efab51f5"}[chunkId] + ".chunk.js";
};